import { FC, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import FormInput from "./FormInput";
import { organizationFormSectionData } from "../configs";
import { IOrganization } from "../types";
import { SelectTypeFormComponent } from "./form-components";
import { AccommodationTypeDto } from "../types/contracts";
import {FormField} from "../types/enums";

type FormOrganizationProps = {
  onFormChange: (organization: IOrganization) => void;
  accommodations: AccommodationTypeDto[];
};

const OrganizationFormSection: FC<FormOrganizationProps> = ({
  onFormChange,
  accommodations,
}) => {
  const {
    register,
    control,
    formState: { errors },
    watch,
  } = useForm({ mode: "onChange" });

  const [
    organizationName,
    address,
    leaderName,
    leaderLastname,
    phoneNumber,
    email,
    accommodationType,
    nameOfAccommodation,
    placeOfAccommodation
  ] = useWatch({
    control,
    name: [
      "organizationName",
      "address",
      "leaderName",
      "leaderLastName",
      "phoneNumber",
      "email",
      "accommodationType",
      FormField.NameOfAccommodation,
      FormField.PlaceOfAccommodation,
    ],
  });

  useEffect(() => {
    onFormChange({
      organizationName: organizationName,
      address: address,
      leaderName,
      leaderLastname,
      phoneNumber: phoneNumber,
      email: email,
      accommodationTypeName:
        accommodations.find((a) => a.id === accommodationType)?.name ?? "",
      accommodationId: accommodationType,
      customAccommodationName: nameOfAccommodation,
      customAccommodationAddress: placeOfAccommodation,
    });
  }, [
    address,
    email,
    leaderName,
    leaderLastname,
    organizationName,
    phoneNumber,
    accommodationType,
    accommodations,
    nameOfAccommodation,
    placeOfAccommodation
  ]);

  return (
    <form
      className="max-w-4xl mx-auto p-6 my-5 bg-white shadow-md rounded-lg"
      //onChange={handleSubmit(onSubmit)}
    >
      <h2 className="text-xl font-semibold mb-4">
        {organizationFormSectionData.title}
      </h2>
      <div className="grid sm:grid-cols-2 gap-4 mb-4">
        {organizationFormSectionData.basicData.map((basicData, index) => (
          <div className="col-span-1" key={index}>
            <FormInput
              key={index}
              register={register}
              errors={errors}
              basicData={basicData}
            />
          </div>
        ))}
        {organizationFormSectionData.accommodationTypeData.name && (
          <SelectTypeFormComponent
            errors={errors}
            register={register}
            selectTypeData={organizationFormSectionData.accommodationTypeData}
            accommodations={accommodations}
            watch={watch}
          />
        )}
        {accommodations.find(
          (type) => type.isSelfArrangedAccommodation && type.id === accommodationType
        ) &&
          organizationFormSectionData.accommodationsData.map(
            (accommodationData, index) => (
              <FormInput
                key={index}
                register={register}
                errors={errors}
                basicData={accommodationData}
              />
            )
          )}
      </div>
    </form>
  );
};

export default OrganizationFormSection;
